export default __webpack_public_path__ + "static/media/qukes-easy-felafel-snack-bowl.15c03404.jpg";